/* global Alpine */
document.addEventListener('alpine:init', () => {
  Alpine.data('navbarComponent', () => ({
    // Existing state properties
    navopen: false,
    desktop: window.innerWidth > 991,
    hoveredtab: 'closed',

    // Scroll tracking state
    tickerVisible: true,
    scrollTimeout: null,

    // Check the current scroll position and update visibility
    checkScroll() {
      const currentScrollY = window.scrollY;
      if (currentScrollY < 100) {
        this.tickerVisible = true;
      } else {
        this.tickerVisible = false;
      }
    },
    
    collapseTicker () {
      const nav = document.querySelector('.nav-div');

      if (nav) {
        const collapseTarget = nav.querySelector('.hello-bar');
        const collapseHeight = collapseTarget ? collapseTarget.offsetHeight * -1 : 0;
        nav.style.setProperty('--collapse-height', `${collapseHeight}px`);
      }
    },

    // Initialization: set up scroll and resize event listeners
    init() {
      window.addEventListener('scroll', () => this.checkScroll());
      window.addEventListener('resize', () => {
        this.desktop = window.innerWidth > 991;
        this.collapseTicker();
      });
      this.collapseTicker();
    }
  }));
});
